import Modal from "antd/lib/modal";
import React from "react";
import { ModalFuncProps } from "antd/lib/modal";
import { TModal } from "./interface";
import "./index.less";
import ZIcon from "../ZIcon";
import { EIcons } from "../ZIcon/interface";

const ZModal: TModal = ({
	children,
	className = "",
	onCancel,
	size = "sm",
	modalBodyClassName = "",
	hideDefaultFooter = false,
	centered = true,
	removeDefaultPadding = false,
	hideCancelButton = false,
	hideOkButton = false,
	cancelButtonProps,
	okButtonProps,
	ignoreSize = false,
	...rest
}) => {
	return (
		<Modal
			destroyOnClose
			onCancel={onCancel}
			centered={centered}
			closeIcon={<ZIcon name={EIcons.CANCEL} size="sm" />}
			cancelButtonProps={
				hideCancelButton
					? { style: { display: "none" } }
					: { ...cancelButtonProps }
			}
			okButtonProps={
				hideOkButton
					? { style: { display: "none" } }
					: { ...okButtonProps }
			}
			{...rest}
			className={`z-modal zModalContainer ${className} ${
				ignoreSize ? "" : `modal-size-${size}`
			} ${hideDefaultFooter ? "hide-default-modal-footer" : ""} ${
				removeDefaultPadding ? "z-modal-no-padding" : ""
			}`}
		>
			<div className={`modalBody ${modalBodyClassName}`}>{children}</div>
		</Modal>
	);
};

ZModal.confirm = ({ maskClosable = true, ...rest }: ModalFuncProps) =>
	Modal.confirm({ maskClosable, ...rest, className: "z-modal-popups" });
ZModal.info = ({ maskClosable = true, ...rest }: ModalFuncProps) =>
	Modal.info({ maskClosable, ...rest, className: "z-modal-popups" });
ZModal.success = ({ maskClosable = true, ...rest }: ModalFuncProps) =>
	Modal.success({ maskClosable, ...rest, className: "z-modal-popups" });
ZModal.error = ({ maskClosable = true, ...rest }: ModalFuncProps) =>
	Modal.error({ maskClosable, ...rest, className: "z-modal-popups" });
ZModal.warning = ({ maskClosable = true, ...rest }: ModalFuncProps) =>
	Modal.warning({ maskClosable, ...rest, className: "z-modal-popups" });
ZModal.deleteConfirm = ({ maskClosable = true, ...rest }: ModalFuncProps) =>
	Modal.confirm({
		maskClosable,
		...rest,
		className: "z-modal-popups",
		okButtonProps: {
			danger: true
		}
	});
ZModal.useModal = Modal.useModal;

export default ZModal;
